module.exports = __webpack_public_path__ + "img/2.682b0517.svg";